import { ApplicationElement, html } from '@effectivastudio/lit-components';

import '@effectivastudio/lit-components/components/avatar/element.js';
import '@effectivastudio/lit-components/components/icon/element.js';
import '@effectivastudio/lit-components/components/timeago/element.js';

import style from './style.lit.css';

/**
 * Card header element used to convey main information about the card.
 *
 * @prop cardType - Card type icon forwarded from Card component (options: event, date, discussion, engagement, marketplace, news, organize, poll)
 * @prop isAnnouncement - Forwarded from Card component; if true, Announcement icon is rendered
 * @prop userPicture - Sender avatar picture
 * @prop userName - Sender full name
 * @prop userUrl - Sender URL
 * @prop origin - Region name
 * @prop timestamp - Card creation time
 *
 */

export default class CardHeader extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    cardType: { type: String },
    isAnnouncement: { type: Boolean },
    userPicture: { type: String },
    userName: { type: String },
    userUrl: { type: String },
    origin: { type: String },
    timestamp: { type: Date },
  };

  /** @internal */
  static TYPE_ICON_NAMES = {
    date: 'calendar-days',
    discussion: 'comments',
    engagement: 'hand-heart',
    event: 'calendar-day',
    marketplace: 'shopping-basket',
    news: 'newspaper',
    organize: 'clipboard-list',
    poll: 'chart-pie',
  };

  connectedCallback() {
    super.connectedCallback();
    this.card = this.closest('xs-card');
    this.cardType = this.card?.cardType;
    this.isAnnouncement = this.card?.isAnnouncement;
  }

  /** @internal */
  get typeIcon() {
    return this.constructor.TYPE_ICON_NAMES[this.cardType];
  }

  render() {
    return html`
      <div class="content-wrapper">
        <ef-avatar
          .picture=${this.userPicture}
          name=${this.userName}
          layout="sm"
          rounded></ef-avatar>
        <div class="content">
          <a href=${this.userUrl}>${this.userName}</a>
          <div class="info">
            <ef-timeago timestamp=${this.timestamp}></ef-timeago>
            ${this.isAnnouncement ? null : html` <span> ${this.origin} </span>`}
          </div>
        </div>
      </div>
      <ef-icon name="${this.isAnnouncement ? 'bullhorn' : this.typeIcon}">
      </ef-icon>
    `;
  }
}

customElements.get('xs-card-header') ||
  customElements.define('xs-card-header', CardHeader);
